<template>
  <div class="layout-side-bar">
    <div
      class="blocks-container"
      :class="{
        collapsed: sidebarStatus === 'collapsed',
        opened: sidebarStatus === 'opened',
      }"
    >
      <div
        :key="key"
        class="block"
        v-for="(item, key) in sidebar"
        @mouseenter="handleMouseOver('enter', key)"
        @mouseleave="handleMouseOver('leave', key)"
        :class="{
          is_hover: item.is_hover,
          first_block: key === 0,
          last_block: key === sidebar.length - 1,
        }"
      >
        <div class="icon-box" v-track :data-oid="item.oid" @click="handleBlockClick(item)">
          <img v-if="item.is_hover" class="img_on_hover" :src="item.img_on_hover" alt="" />
          <img v-else class="img" :src="item.img" alt="" />
          <span class="name">{{ item.name }}</span>
        </div>
        <div class="bay" v-if="item.has_bay && item.is_hover && item.bay_data" v-track :data-oid="item.bay_oid">
          <div class="content" v-html="item.bay_data" />
        </div>
      </div>

      <!-- 收起按钮 -->
      <div class="collapse" @click="handleCollapseClick">
        <i class="iconfont" :class="sidebarStatus === 'collapsed' ? 'icon-arrow-left' : ' icon-arrow-right'" />
      </div>
    </div>

    <!-- 回到顶部 -->
    <div
      class="block back_to_top"
      @click="handleBackToTop"
      :style="{ visibility: backToTopVisible ? 'visible' : 'hidden' }"
    >
      <i class="iconfont icon-fanhuidingbu" />
      <span class="name">顶部</span>
    </div>

    <!-- 新手指南入口 -->
    <div
      class="block newbie_guide_entry"
      v-if="userGuide.newUserFlag && !isSimulatedLogin"
      @click="handleNewbieGuideEntryClick"
    >
      <img class="img" src="@/assets/img/LayoutSidebar/icon-newbie-guide-entry.png" alt="" />
    </div>

    <!-- 下载APP -->
    <DownloadGuide v-if="isShowSidebarDownloadGuide" />
  </div>
</template>

<script>
import { AUTO_BAY, AUTO_BAY_NAMESPACE, SIDEBAR_ITEMS, SIDEBAR_NAMESPACE } from "@/utils/constants/constants.layout";
import { authCheck, deepClone } from "@/utils/common";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";
import { AUTH_KEY_MAP } from "@/utils/constants/constants.auth";
import DownloadGuide from "@/components/LayoutSidebar/DownloadGuide";
import { restAccountPopupGetLog } from "@/services/common/basic";

export default {
  name: "LayoutSidebar",
  components: { DownloadGuide },
  data() {
    return {
      sidebar: [],
      sidebarStatus: "",
      backToTopVisible: false,
      FloatTime: {},
      FloatData: {},
    };
  },
  computed: {
    sidebarConditions() {
      return {
        localAuth: this.$store.getters["basic/localAuth"],
        route: this.$route,
      };
    },
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    userGuide() {
      return this.$store.getters["basic/userGuide"];
    },
    isSimulatedLogin() {
      return this.$store.getters["basic/isSimulatedLogin"];
    },
    isShowSidebarDownloadGuide() {
      return this.$route.meta.isShowSidebarDownloadGuide;
    },
  },
  watch: {
    sidebarConditions(newV) {
      this.setSidebarBlocks();
      this.setAutoBay(newV.route);
    },
  },
  methods: {
    handleBackToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleNewbieGuideEntryClick() {
      this.$store.commit("helpCenter/updateIsShowPopupNewbieTasks", true);
      this.$track(DEED_MAP.CLICK, OID_MAP.NEWBIE_TASK_SIDEBAR_ENTRY_CLICK);
    },
    handleMouseOver(status, index) {
      if (status === "enter") {
        this.sidebar[index].is_hover = true;
      }
      if (status === "leave") {
        this.sidebar[index].is_hover = false;
      }
    },
    handleBlockClick(item) {
      if (!item.link) return;
      switch (item.id) {
        case SIDEBAR_NAMESPACE.PRESALE_CONSULT:
          window.open(item.link + `?orgid=${this.userInfo.userId}`);
          break;
        default:
          window.open(item.link);
      }
    },
    setSidebarBlocks() {
      const sidebar = [];
      if (authCheck(AUTH_KEY_MAP.SIDEBAR_PRESALE_CONSULT)) {
        sidebar.push(SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.SALES_WECHAT));
      }
      // 在线咨询显示逻辑 非免费用户
      if (authCheck(AUTH_KEY_MAP.SIDEBAR_ONLINE_CONSULT)) {
        sidebar.push(SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.ONLINE_CONSULT));
      }

      // 咨询热线
      const hot_line_block = SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.HOT_LINE);
      sidebar.push(hot_line_block);

      // 售前咨询 免费用户
      if (authCheck(AUTH_KEY_MAP.SIDEBAR_PRESALE_CONSULT)) {
        sidebar.push(SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.PRESALE_CONSULT));
      }

      // APP
      sidebar.push(SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.APP));

      // 服务号
      // todo 后期开发详情页时，需要动态
      sidebar.push(SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.SERVICE_ACCOUNT));

      // 帮助中心
      sidebar.push(SIDEBAR_ITEMS().find((v) => v.id === SIDEBAR_NAMESPACE.HELP_CENTER));

      this.sidebar = sidebar;
    },
    async setAutoBay(route) {
      const sidebar = deepClone(this.sidebar);
      /** 帮助中心自动气泡 **/
      const AUTO_BAY_HELP_CENTER = AUTO_BAY.find((v) => v.id === SIDEBAR_NAMESPACE.HELP_CENTER);
      const sidebar_help_center = sidebar.find((v) => v.id === SIDEBAR_NAMESPACE.HELP_CENTER);
      /** 找商机 - 标讯 **/
      const auto_bay = route.meta.sidebar ? route.meta.sidebar.auto_bay : [];
      if (auto_bay.includes(AUTO_BAY_NAMESPACE.HELP_CENTER_BIDDING_INFO)) {
        const AUTO_BAY_HELP_CENTER_BIDDING_INFO = AUTO_BAY_HELP_CENTER.children.find(
          (v) => v.id === AUTO_BAY_NAMESPACE.HELP_CENTER_BIDDING_INFO
        );
        sidebar_help_center.link = AUTO_BAY_HELP_CENTER_BIDDING_INFO.href;
        sidebar_help_center.has_bay = true;
        sidebar_help_center.bay_data = `
                                <div class="arrow"></div>
                                <a class="help-center-bay" href="${AUTO_BAY_HELP_CENTER_BIDDING_INFO.href}" target="_blank">
                                  <div class="tip" > ${AUTO_BAY_HELP_CENTER_BIDDING_INFO.text}</div>
                                  <img class="img" src="${AUTO_BAY_HELP_CENTER_BIDDING_INFO.img}" alt="" />
                                </a>`;
        sidebar_help_center.bay_oid = AUTO_BAY_HELP_CENTER_BIDDING_INFO.bay_oid;
        sidebar_help_center.is_hover = await restAccountPopupGetLog({ type: 8 }).then((res) => !res.data);
        if (sidebar_help_center.is_hover) {
          clearTimeout(sidebar_help_center.timer);
          // 30s后自动消失
          sidebar_help_center.timer = setTimeout(() => {
            sidebar_help_center.is_hover = false;
          }, 30 * 1000);
        }
      }
      /** 找商机 - 拟建 **/
      if (auto_bay.includes(AUTO_BAY_NAMESPACE.HELP_CENTER_CONSTR_PROJECT)) {
        const AUTO_BAY_HELP_CENTER_CONSTR_PROJECT = AUTO_BAY_HELP_CENTER.children.find(
          (v) => v.id === AUTO_BAY_NAMESPACE.HELP_CENTER_CONSTR_PROJECT
        );
        sidebar_help_center.link = AUTO_BAY_HELP_CENTER_CONSTR_PROJECT.href;
        sidebar_help_center.has_bay = true;
        sidebar_help_center.bay_data = `
                                <div class="arrow"></div>
                                <a class="help-center-bay" href="${AUTO_BAY_HELP_CENTER_CONSTR_PROJECT.href}" target="_blank">
                                  <div class="tip" > ${AUTO_BAY_HELP_CENTER_CONSTR_PROJECT.text}</div>
                                  <img class="img" src="${AUTO_BAY_HELP_CENTER_CONSTR_PROJECT.img}" alt="" />
                                </a>`;
        sidebar_help_center.bay_oid = AUTO_BAY_HELP_CENTER_CONSTR_PROJECT.bay_oid;
        sidebar_help_center.is_hover = await restAccountPopupGetLog({ type: 9 }).then((res) => !res.data);
        if (sidebar_help_center.is_hover) {
          clearTimeout(sidebar_help_center.timer);
          // 30s后自动消失
          sidebar_help_center.timer = setTimeout(() => {
            sidebar_help_center.is_hover = false;
          }, 30 * 1000);
        }
      }
      /** 找商机 - 审批 **/
      if (auto_bay.includes(AUTO_BAY_NAMESPACE.HELP_CENTER_EXAMINE_PROJECT)) {
        const AUTO_BAY_HELP_CENTER_EXAMINE_PROJECT = AUTO_BAY_HELP_CENTER.children.find(
          (v) => v.id === AUTO_BAY_NAMESPACE.HELP_CENTER_EXAMINE_PROJECT
        );
        sidebar_help_center.link = AUTO_BAY_HELP_CENTER_EXAMINE_PROJECT.href;
        sidebar_help_center.has_bay = true;
        sidebar_help_center.bay_data = `
                                <div class="arrow"></div>
                                <a class="help-center-bay" href="${AUTO_BAY_HELP_CENTER_EXAMINE_PROJECT.href}" target="_blank">
                                  <div class="tip" > ${AUTO_BAY_HELP_CENTER_EXAMINE_PROJECT.text}</div>
                                  <img class="img" src="${AUTO_BAY_HELP_CENTER_EXAMINE_PROJECT.img}" alt="" />
                                </a>`;
        sidebar_help_center.bay_oid = AUTO_BAY_HELP_CENTER_EXAMINE_PROJECT.bay_oid;
        sidebar_help_center.is_hover = await restAccountPopupGetLog({ type: 10 }).then((res) => !res.data);
        if (sidebar_help_center.is_hover) {
          clearTimeout(sidebar_help_center.timer);
          // 30s后自动消失
          sidebar_help_center.timer = setTimeout(() => {
            sidebar_help_center.is_hover = false;
          }, 30 * 1000);
        }
      }
      /** 订阅 - 标讯 **/
      if (auto_bay.includes(AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_BIDDING_INFO)) {
        const AUTO_BAY_HELP_CENTER_SUB_BIDDING_INFO = AUTO_BAY_HELP_CENTER.children.find(
          (v) => v.id === AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_BIDDING_INFO
        );
        sidebar_help_center.link = AUTO_BAY_HELP_CENTER_SUB_BIDDING_INFO.href;
        sidebar_help_center.has_bay = true;
        sidebar_help_center.bay_data = `
                                <div class="arrow"></div>
                                <a class="help-center-bay" href="${AUTO_BAY_HELP_CENTER_SUB_BIDDING_INFO.href}" target="_blank">
                                  <div class="tip" > ${AUTO_BAY_HELP_CENTER_SUB_BIDDING_INFO.text}</div>
                                  <img class="img" src="${AUTO_BAY_HELP_CENTER_SUB_BIDDING_INFO.img}" alt="" />
                                </a>`;
        sidebar_help_center.bay_oid = AUTO_BAY_HELP_CENTER_SUB_BIDDING_INFO.bay_oid;
        sidebar_help_center.is_hover = await restAccountPopupGetLog({ type: 13 }).then((res) => !res.data);
        if (sidebar_help_center.is_hover) {
          clearTimeout(sidebar_help_center.timer);
          // 30s后自动消失
          sidebar_help_center.timer = setTimeout(() => {
            sidebar_help_center.is_hover = false;
          }, 30 * 1000);
        }
      }
      /** 订阅 - 拟建 **/
      if (auto_bay.includes(AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_CONSTR_PROJECT)) {
        const AUTO_BAY_HELP_CENTER_SUB_CONSTR_PROJECT = AUTO_BAY_HELP_CENTER.children.find(
          (v) => v.id === AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_CONSTR_PROJECT
        );
        sidebar_help_center.link = AUTO_BAY_HELP_CENTER_SUB_CONSTR_PROJECT.href;
        sidebar_help_center.has_bay = true;
        sidebar_help_center.bay_data = `
                                <div class="arrow"></div>
                                <a class="help-center-bay" href="${AUTO_BAY_HELP_CENTER_SUB_CONSTR_PROJECT.href}" target="_blank">
                                  <div class="tip" > ${AUTO_BAY_HELP_CENTER_SUB_CONSTR_PROJECT.text}</div>
                                  <img class="img" src="${AUTO_BAY_HELP_CENTER_SUB_CONSTR_PROJECT.img}" alt="" />
                                </a>`;
        sidebar_help_center.bay_oid = AUTO_BAY_HELP_CENTER_SUB_CONSTR_PROJECT.bay_oid;
        sidebar_help_center.is_hover = await restAccountPopupGetLog({ type: 14 }).then((res) => !res.data);
        if (sidebar_help_center.is_hover) {
          clearTimeout(sidebar_help_center.timer);
          // 30s后自动消失
          sidebar_help_center.timer = setTimeout(() => {
            sidebar_help_center.is_hover = false;
          }, 30 * 1000);
        }
      }
      /** 订阅 - 审批 **/
      if (auto_bay.includes(AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_EXAMINE_PROJECT)) {
        const AUTO_BAY_HELP_CENTER_SUB_EXAMINE_PROJECT = AUTO_BAY_HELP_CENTER.children.find(
          (v) => v.id === AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_EXAMINE_PROJECT
        );
        sidebar_help_center.link = AUTO_BAY_HELP_CENTER_SUB_EXAMINE_PROJECT.href;
        sidebar_help_center.has_bay = true;
        sidebar_help_center.bay_data = `
                                <div class="arrow"></div>
                                <a class="help-center-bay" href="${AUTO_BAY_HELP_CENTER_SUB_EXAMINE_PROJECT.href}" target="_blank">
                                  <div class="tip" > ${AUTO_BAY_HELP_CENTER_SUB_EXAMINE_PROJECT.text}</div>
                                  <img class="img" src="${AUTO_BAY_HELP_CENTER_SUB_EXAMINE_PROJECT.img}" alt="" />
                                </a>`;
        sidebar_help_center.bay_oid = AUTO_BAY_HELP_CENTER_SUB_EXAMINE_PROJECT.bay_oid;
        sidebar_help_center.is_hover = await restAccountPopupGetLog({ type: 15 }).then((res) => !res.data);
        if (sidebar_help_center.is_hover) {
          clearTimeout(sidebar_help_center.timer);
          // 30s后自动消失
          sidebar_help_center.timer = setTimeout(() => {
            sidebar_help_center.is_hover = false;
          }, 30 * 1000);
        }
      }
      /** 帮助中心自动气泡 end **/

      this.sidebar = sidebar;
    },
    handleCollapseClick() {
      if (this.sidebarStatus === "collapsed") {
        this.sidebarStatus = "opened";
      } else {
        this.sidebarStatus = "collapsed";
      }
    },
    eventListeners() {
      window.addEventListener("scroll", (e) => {
        const { scrollTop, clientHeight } = e.target.documentElement;
        this.backToTopVisible = scrollTop >= clientHeight;
      });
    },
  },
  mounted() {
    this.eventListeners();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", () => {});
  },
};
</script>

<style scoped lang="scss">
@import "../assets/config.scss";

.collapsed {
  animation: collapsed 0.15s ease-in 1;
  animation-fill-mode: forwards; // 让css保持在动画停止的状态
}

.opened {
  animation: opened 0.15s ease-in 1;
  animation-fill-mode: forwards; // 让css保持在动画停止的状态
}

@keyframes collapsed {
  from {
    right: 0;
  }
  to {
    right: -$layout-side-bar-width;
  }
}

@keyframes opened {
  from {
    right: -$layout-side-bar-width;
  }
  to {
    right: 0;
  }
}

.layout-side-bar {
  width: $layout-side-bar-width;
  height: fit-content;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  right: 0;
  z-index: 1;
  background-color: transparent;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .blocks-container {
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 6%);
    background-color: white;
    position: relative;
    transition: all 0.2s ease-in;

    .collapse {
      width: 20px;
      height: 60px;

      box-shadow: -3px 2px 4px -1px rgb(0 0 0 / 6%);
      background: #fff;
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
      font-size: 16px;
      color: #ccc;

      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: -20px;

      display: flex;
      justify-content: center;
      align-items: center;

      cursor: pointer;
    }
  }

  .block {
    flex-shrink: 0;
    width: 100%;
    height: 63px;
    margin-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: $theme-font-color;
    background-color: white;
    position: relative;

    .icon-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    img {
      width: 26px;
      height: 26px;
      object-fit: contain;
    }

    .name {
      font-size: 12px;
    }

    .bay {
      border: 0.5px rgba(0, 0, 0, 0.1) solid;
      box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 6%);
      border-radius: 5px;

      position: absolute;

      top: 0;
      right: 70px;
      z-index: 1;

      padding: 8px 5px;
      background-color: white;

      color: #888;

      .content {
        display: flex;
        flex-direction: column;
        margin-right: -20px;
        padding-right: 20px;

        ::v-deep .arrow {
          border-top: 0.5px rgba(0, 0, 0, 0.1) solid;
          border-right: 0.5px rgba(0, 0, 0, 0.1) solid;
          width: 10px;
          height: 10px;
          position: absolute;
          right: -5px;
          top: 20px;
          transform: rotate(45deg);
          background-color: white;
          z-index: -1;
        }

        ::v-deep .qrcode {
          width: 150px;
          height: 150px;
          object-fit: cover;
        }

        ::v-deep .help-center-bay {
          .tip {
            color: #333;
            font-size: 12px;
            font-weight: normal;
            white-space: inherit;
            text-align: left;
            line-height: 17px;
            padding: 4px 12px 0px;
          }
          .img {
            width: 174px;
            height: 104px;
            margin: 10px;
          }
        }

        ::v-deep .tip {
          text-align: center;
          white-space: nowrap;
          padding: 0 10px;
        }
      }
    }
  }

  .last_block {
    margin-bottom: 0;
    border-bottom-left-radius: 4px;
  }

  .first_block {
    border-top-left-radius: 4px;
  }

  .back_to_top {
    height: 78px;
    color: $theme-color;
    margin-top: 18px;
    margin-bottom: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 6%);

    i {
      font-weight: 600;
      font-size: 21px;
    }

    .name {
      color: $theme-font-color;
    }

    &:hover {
      color: white;
      background-color: $theme-color;

      .name {
        color: white;
      }
    }
  }

  .is_hover {
    color: white;
    background-color: $theme-color;
  }

  .newbie_guide_entry {
    width: fit-content;
    height: fit-content;
    color: $theme-color;
    margin-top: 18px;
    margin-bottom: 0;
    position: relative;
    right: 18px;

    img {
      width: 73px;
      height: 80px;
    }
  }
}
</style>
